import React from 'react'

import { Checkbox } from 'components'
import { getHours, getMinutes, parseISO } from 'date-fns'
import type { IUser } from 'features/Ticket'
import clsx from 'clsx'

interface IEvent {
  eventTitle: string
  assignStartPosition: number
  assignEndPosition: number
}

interface Props {
  dateHours: Date[]
  user: IUser
  checked: boolean
  shouldEventTagGray: boolean
  onSelectUser: (checked: boolean, user: IUser) => void
  onBlockClick: (dateHour: Date) => void
}

// Variable for handle event tag position.
// !If you have to change these, change in scss(_TicketCalendar.scss) too.
const borderWidth = 1
const hourSize = 60 * 1.8 - borderWidth
const cardWidth = 176
const rowWidth = hourSize * 24

const TicketCalendarSingle: React.FC<Props> = ({
  dateHours,
  user,
  checked,
  shouldEventTagGray,
  onSelectUser,
  onBlockClick,
}: Props) => {
  const base = 'ticket-calendar'
  const userNameTitle = `(${user.nickName}) ${user.firstName} ${user.lastName}`
  const userPhoneNumber = `${user.countryCode}${user.phoneNumber}`

  const getPosition = (date: string): number => {
    const hourInMinute = getHours(parseISO(date)) * 60
    const minute = getMinutes(parseISO(date))
    const position = (hourSize / 60) * (hourInMinute + minute)

    return position
  }

  const events: IEvent[] = user.tasks.map((task) => {
    const assignStartPosition = getPosition(task.assignStart)

    return {
      eventTitle: task.branchName,
      assignStartPosition: cardWidth + assignStartPosition - borderWidth,
      assignEndPosition: rowWidth - getPosition(task.assignEnd),
    }
  })

  return (
    <div className={`${base}__row`}>
      <div className={`${base}__card`}>
        <Checkbox
          name='_'
          className={`${base}__checkbox`}
          checked={checked}
          onChange={(value) => onSelectUser(value, user)}
        />
        <div className={`${base}__card-info`}>
          <div className={`${base}__card-staff-name`}>{userNameTitle}</div>
          <span className={`${base}__card-text`}>{userPhoneNumber}</span>
        </div>
      </div>
      {dateHours.map((dateHour, index) => (
        <div
          key={index}
          data-testid={`date-hour-${index}`}
          className={`${base}__hour-block`}
          onClick={() => onBlockClick(dateHour)}
        />
      ))}
      {events.map((task, index) => (
        <div
          key={index}
          data-testid={`event-${index}`}
          style={{
            left: task.assignStartPosition,
            right: task.assignEndPosition,
          }}
          className={clsx(
            `${base}__event-tag`,
            shouldEventTagGray && `${base}__event-tag--un-selected`,
          )}
        >
          {task.eventTitle}
        </div>
      ))}
    </div>
  )
}

export default TicketCalendarSingle
